import React, { Component, useState, useEffect, useContext } from 'react'
import ReactDOM from 'react-dom'
import _ from 'underscore'

import './css/styles.scss'

import LocationClass from './../../../../../../../js/classes/Location.js'
import AppClass from './../../../../../../../js/classes/App.js'

import SelectButton from './SelectButton.jsx'
import SelectLocation from './SelectLocation.jsx'

const SelectLocationApp = () => {
    const [isShow, setShow] = useState(false),
    [currentTown, setCurrentTown] = useState(null),
    [locations, setLocations] = useState([]),
    refetch = (cb, isCart) => {
        LocationClass.getList((err, res) => {
            if (err) {

            } else {
                setLocations(res)
            }
        }, isCart ? _.compact(__HappySelectCartLocations) : _.compact(__HappySelectLocations))
    },
    handleSetCurrentTown = (locationId, locationCity) => {
        const newLocation = {
            'ID' : locationId,
            'NAME' : locationCity
        }

        setCurrentTown(newLocation)

        AppClass.setCookie("BITRIX_SM_SELECT_LOCATION_TOWN", locationId, {
            expires : new Date((new Date().getTime() + 1000 * 60 * 60 * 24 * 365)),
            path : '/'
        })

        AppClass.runCallback('select_location_change', newLocation)

        setShow(false)
    }

    useEffect(() => {
        refetch()
        
        LocationClass.current((err, res) => {
            if (err) {
                
            } else {
                if (res) {
                    setCurrentTown({
                        ID : res.ID,
                        NAME : res.CITY
                    })
                } else {
                    setCurrentTown(false)
                    setShow(true)
                }
            }
        })

        document.querySelector('body').addEventListener('keydown', (e) => {
            if (e.which === 27) {
                setShow(false)
            }
        })

        AppClass.addCallback('select_location_show', (isShow=true, isCart) => {
            /*refetch(() => {

            }, isCart ? true : false)*/

            setShow(!!isShow)
        })
    }, [])

    return <div className="happy-select-location">
        {/*<SelectButton isShow={ isShow } setShow={ setShow } currentTown={ currentTown } />*/}
        <SelectLocation
            isShow={ isShow }
            setShow={ setShow }
            locations={ locations }
            handleSetCurrentTown={ handleSetCurrentTown }
        />
    </div>
}

const container = document.getElementById('root-happy-select-location')

if (container) ReactDOM.render(<SelectLocationApp />, container)